import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import "./Home.css";
import StatisticsSection from "../components/StatisticsSection";
import Main from "../components/Main";
import PhoneSection from "../components/PhoneSection";
import EventSection from "../components/EventSection";
import CleanWorkSection from "../components/CleanWorkSection";
import PartnersSection from "../components/PartnersSection";
import InformationSection from "../components/InformationSection";

function Home() {
  const [isStatisticsInViewport, setIsStatisticsInViewport] = useState(false); // StatisticsSection 뷰포트 내 상태
  const [statisticsRenderCount, setStatisticsRenderCount] = useState(0); // StatisticsSection 리렌더링 트리거
  const [isInformationInViewport, setIsInformationInViewport] = useState(false); // InformationSection 뷰포트 내 상태
  const [informationRenderCount, setInformationRenderCount] = useState(0); // InformationSection 리렌더링 트리거
  const statisticsRef = useRef(null); // StatisticsSection 감지용 ref
  const informationRef = useRef(null); // InformationSection 감지용 ref
  const GOOGLE_MAPS_API_KEY = "AIzaSyDna72vBFi45ykSWDFiqyPYGaiF3Ul38J4"; // 발급받은 API 키
  const location = "서울특별시 금천구 가산디지털2로 143"; // 원하는 주소나 좌표 입력

  useEffect(() => {
    const curStatistics = statisticsRef.current;
    const curInformation = informationRef.current
    const handleIntersection = (entries, observer, setInViewport, setRenderCount) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        setInViewport(true);
        setRenderCount((prev) => prev + 1); // 리렌더링 트리거
      } else {
        setInViewport(false);
      }
    };

    // StatisticsSection Observer
    const statisticsObserver = new IntersectionObserver(
      (entries) => handleIntersection(entries, statisticsObserver, setIsStatisticsInViewport, setStatisticsRenderCount),
      { threshold: 0.2 }
    );

    // InformationSection Observer
    const informationObserver = new IntersectionObserver(
      (entries) => handleIntersection(entries, informationObserver, setIsInformationInViewport, setInformationRenderCount),
      { threshold: 0.2 }
    );

    if (curStatistics) {
      statisticsObserver.observe(curStatistics);
    }
    if (curInformation) {
      informationObserver.observe(curInformation);
    }

    return () => {
      if (curStatistics) statisticsObserver.unobserve(curStatistics);
      if (curInformation) informationObserver.unobserve(curInformation);
    };
  }, []);

  return (
    <div>
      <Helmet>
        <title>채움기획</title>
        <meta name="description" content="채움기획은 네이버 노출 최적화와 광고 기획을 전문으로 합니다." />
        <meta name="keywords" content="네이버 광고, 최적화, 마케팅, 채움기획, Home" />
        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "BreadcrumbList",
              "@id": "https://cheumad.kr/#breadcrumblist",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "@id": "https://cheumad.kr/#listItem",
                  "position": 1,
                  "name": "홈",
                  "item": "https://cheumad.kr/"
                }
              ]
            },
            {
              "@type": "Organization",
              "@id": "https://cheumad.kr/#organization",
              "name": "채움기획",
              "url": "https://cheumad.kr/",
              "logo": "https://cheumad.kr/logo.png",
              "contactPoint": [
                {
                  "@type": "ContactPoint",
                  "Owner": "홍성준",
                  "E-mail": "fate_ad@naver.com",
                }
              ]
            },
            {
              "@type": "WebPage",
              "@id": "https://cheumad.kr/#webpage",
              "url": "https://cheumad.kr/",
              "name": "채움기획",
              "inLanguage": "ko-KR",
              "isPartOf": {
                "@id": "https://cheumad.kr/#website"
              },
              "breadcrumb": {
                "@id": "https://cheumad.kr/#breadcrumblist"
              },
              "datePublished": "2025-01-01T00:00:00+09:00",
              "dateModified": "2025-01-01T00:00:00+09:00"
            },
            {
              "@type": "WebSite",
              "@id": "https://cheumad.kr/#website",
              "url": "https://cheumad.kr/",
              "name": "채움기획",
              "inLanguage": "ko-KR",
              "publisher": {
                "@id": "https://cheumad.kr/#organization"
              }
            },
            {
              "@type": "SiteNavigationElement",
              "@id": "https://cheumad.kr/#siteNavigation",
              "name": ["포트폴리오", "문의하기"],
              "url": ["https://cheumad.kr/portfolio", "https://cheumad.kr/contact"]
            }
          ]
        })}
        </script>
      </Helmet>
      <Main />
      <div
        ref={statisticsRef}
        style={{
          opacity: isStatisticsInViewport ? 1 : 0,
          visibility: isStatisticsInViewport ? "visible" : "hidden",
          transition: "opacity 0.5s ease",
        }}
      >
        <StatisticsSection key={statisticsRenderCount} />
      </div>
      <PhoneSection />
      <EventSection />
      <div
        ref={informationRef}
        style={{
          opacity: isInformationInViewport ? 1 : 0,
          visibility: isInformationInViewport ? "visible" : "hidden",
          transition: "opacity 0.5s ease",
        }}
      >
        <InformationSection key={informationRenderCount} />
      </div>
      <CleanWorkSection />
      <PartnersSection />
      <div className="section-divider"></div>
      <h2 className="map-title">오시는 길</h2>
      <div className="map-container">
        <iframe
          title="Google Maps"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_API_KEY}&q=${encodeURIComponent(location)}`}
        ></iframe>
      </div>
    </div>
  );
}

export default Home;
